exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".typography_heading__3YZ28 {\n  margin: 30px 0;\n  font-family: 'PT Serif';\n  font-size: 32px;\n  color: #3C4144;\n  font-weight: 400; }\n\n.typography_title__1YU7x {\n  font-family: 'Roboto';\n  font-weight: 700;\n  font-size: 28px;\n  margin: 0 0 10px; }\n\n.typography_text__pzpH4 {\n  font-family: 'Roboto';\n  font-size: 17px;\n  margin: 0 0 10px; }\n", ""]);

// Exports
exports.locals = {
	"heading": "typography_heading__3YZ28",
	"title": "typography_title__1YU7x",
	"text": "typography_text__pzpH4"
};